import React, { useEffect, useState, useRef } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadAccountBook,
  fetchFinanceJournalEntry,
  fetchFinanceLedgerAcc,
  fetchFinanceLedgerAccBook,
} from "../../../services/finance/finance"
import moment from "moment"
import JournalEntryFilter from "./filter"
import { Link, useLocation, useNavigate } from "react-router-dom"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/actions"

const LedgerAccounts = ({ fromDashboard }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const query = new URLSearchParams(location.search)
  const bread = location?.state?.bread

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log(`filters`, filters)

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  console.log(`finance-ledger-acc`, location)

  const crumb = location?.state?.menuLabell || ""
  const { nameCiH, NewnameCiH, CHI } = location?.state || ""

  const locations = useLocation()
  const crumbaa = locations?.state?.menuLabels || ""
  const crumbdd = locations?.state?.menuLabel || ""
  // const group = locations?.state?.group || ""
  // const myObjectString = JSON.stringify(group);
  // const searchs = locations?.state?.search || ""
  const path = window.location.pathname

  console.log("groupasdads", crumbdd, path, crumbaa)

  // if (myObjectString || searchs) {
  //   localStorage.setItem("groups_id", myObjectString ? myObjectString : "")
  //   localStorage.setItem("searchs_text", searchs ? searchs : "")
  // }

  const companyname = localStorage.getItem("companyname")
  document.title = `${
    // location?.pathname == "/finance-ledger-acc"
    //   ? "Ledger Account"
    //   : "Ledger Summary"
    location?.pathname == "/finance-ledger-acc"
      ? "Ledger Account"
      : location?.pathname == "/finance/sundry-debtors"
      ? "Client Report"
      : location?.pathname == "/finance/account-payable"
      ? "Supplier Report"
      : "Ledger Summary"
  }${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [dateFrom, setDatefrom] = useState(location?.state?.startDate ?? "")
  const [dateTo, setDateto] = useState(location?.state?.endDate ?? "")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [acc, setAcc] = useState(
    location?.state?.item?.ledger_id ||
      location?.state?.ledger_id ||
      location?.state?.id ||
      location?.state?.item?.id ||
      null
  )
  const [accData, setAccData] = useState()
  const [refresh, setRefresh] = useState(0)
  // const [isLoading, setIsLoading] = useState(false)

  // const handleDatas = data => {
  //   const { search, ledger_id, req_date } = data
  //   console.log("data ledger_id", ledger_id)

  //   setSearch(search)
  //   setAcc(ledger_id?.value)
  //   setDatefrom(req_date?.length ? req_date[0] : null)
  //   setDateto(req_date?.length ? req_date[1] : null)
  //   setPage(1)
  //   setRefresh(refresh + 1)
  // }

  console.log(`acc fil`, filters?.accData, location)

  useEffect(() => {
    const fetchData = async () => {
      if (filters?.accData || filters?.dateFrom || filters?.dateTo) {
        // filters?.accData?.value
        //   ? filters?.accData?.value
        //   :
        try {
          // setFetchedData(null)
          const ledgerId =
            location?.state?.item?.ledger_id ||
            location?.state?.ledger_id ||
            location?.state?.id ||
            location?.state?.item?.id ||
            filters?.accData?.value ||
            ""

          const response = await fetchFinanceLedgerAccBook({
            params: `${search ? `&searchText=${search}` : "&searchText"}${
              page ? `&page=${page}` : ""
            }${`&sortOrder=asc`}${
              filters?.dateFrom
                ? `&start_date=${moment(filters?.dateFrom).format(
                    "YYYY-MM-DD"
                  )}`
                : ""
            }${
              filters?.dateTo
                ? `&end_date=${moment(filters?.dateTo).format("YYYY-MM-DD")}`
                : ""
            }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${
              ledgerId ? `&ledger_id=${ledgerId}` : ""
            }`,
          })
          const filteredData = response.data.data.filter(
            item => item.voucher_type !== "Opening Balance"
          )

          if (page > 1 && isLoadingNextPage) {
            setFetchedData(prev => ({
              ...response,
              data: {
                ...response.data,
                data: [...(prev.data.data || []), ...filteredData],
              },
            }))
          } else {
            setFetchedData({
              ...response,
              data: {
                ...response.data,
                data: filteredData,
              },
            })
          }
          setIsLoadingNextPage(response == undefined ? true : false)
          isLoadingRef.current = false
          // console.log(`cleanedResponse`, cleanedResponse)
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      }
    }

    // Check if we have either acc from state or from location.state
    if (
      filters?.accData?.value !== undefined ||
      location?.state?.item?.ledger_id ||
      location?.state?.ledger_id ||
      location?.state?.id ||
      location?.state?.item?.id
    ) {
      fetchData()
    }
  }, [filters?.accData, filters?.dateFrom, filters?.dateTo, page])

  useEffect(() => {
    if (filters?.accData || filters?.dateFrom || filters?.dateTo) return
    const fetchData = async () => {
      try {
        // setFetchedData(null)
        const ledgerId = acc
          ? acc
          : location?.state?.item?.ledger_id ||
            location?.state?.ledger_id ||
            location?.state?.id ||
            location?.state?.item?.id ||
            filters?.accData?.value ||
            ""

        const response = await fetchFinanceLedgerAccBook({
          params: `${search ? `&searchText=${search}` : "&searchText"}${
            page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${
            dateFrom
              ? `&start_date=${moment(dateFrom).format("YYYY-MM-DD")}`
              : ""
          }${dateTo ? `&end_date=${moment(dateTo).format("YYYY-MM-DD")}` : ""}${
            dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
          }${ledgerId ? `&ledger_id=${ledgerId}` : ""}`,
        })

        // const cleanedResponse = {
        //   ...response,
        //   data: {
        //     ...response.data,
        //     data: response.data.data.filter(
        //       item => item.voucher_type !== "Opening Balance"
        //     ),
        //   },
        // }

        // setFetchedData(cleanedResponse)
        const filteredData = response.data.data.filter(
          item => item.voucher_type !== "Opening Balance"
        )

        if (page > 1 && isLoadingNextPage) {
          setFetchedData(prev => ({
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data.data || []), ...filteredData],
            },
          }))
        } else {
          setFetchedData({
            ...response,
            data: {
              ...response.data,
              data: filteredData,
            },
          })
        }
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false
        // console.log(`cleanedResponse`, cleanedResponse)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    // Check if we have either acc from state or from location.state
    if (
      acc !== undefined ||
      location?.state?.item?.ledger_id ||
      location?.state?.ledger_id ||
      location?.state?.id ||
      location?.state?.item?.id
    ) {
      fetchData()
    }
  }, [page, refresh, location, acc, dateFrom, dateTo, dataPerPage])
  const shouldShowLedgerColumn = !(
    location?.state?.item?.ledger_name ||
    location?.state?.name ||
    location?.state?.ledger_name
  )

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    // ...(shouldShowLedgerColumn ? [
    // {
    //   label: "Ledger",
    //   renderCell: item => (
    //     <div className="text-capitalize">
    //       {item?.ledger?.name ? item?.ledger?.name : "-"}
    //     </div>
    //   ),
    // },
    // ]: []),
    {
      label: "Date",
      renderCell: item => (
        <span>{moment(item?.transaction_date).format("DD-MMM-YYYY")}</span>
      ),
    },
    {
      label: "Voucher No",
      renderCell: item => (
        // <div
        //   className="text-capitalize pointer fw-bold"
        //   onClick={() => {
        //     navigate(`/finance-voucher/view/${item?.voucher_id}`, {
        //     state: {
        //       nameCrumb: "ledger", newName: location?.pathname == "/finance-ledger-acc"
        //         ? "Ledger Account"
        //         : "Ledger Summary", nameCiH: nameCiH, NewnameCiH: NewnameCiH, CHI: CHI
        //     }
        //   })
        //   dispatch(setFilter({accData: accData, dateFrom: dateFrom, dateTo: dateTo}))
        // }}
        // >
        //   {item?.reference_number}
        // </div>
        <div className="text-link">
          <Link
            to={`/finance-voucher/view/${item?.voucher_id}`}
            state={{
              nameCrumb: "ledger",
              newName:
                location?.pathname === "/finance-ledger-acc"
                  ? "Ledger Account"
                  : "Ledger Summary",
              nameCiH,
              NewnameCiH,
              CHI,
            }}
            onClick={() =>
              dispatch(
                setFilter({
                  accData: accData,
                  dateFrom: dateFrom,
                  dateTo: dateTo,
                })
              )
            }
            className="text-capitalize pointer fw-bold"
          >
            {item?.reference_number}
          </Link>
        </div>
      ),
    },
    {
      label: "Voucher Type",
      renderCell: item => (
        <div className="text-capitalize">{item?.voucher_type}</div>
      ),
    },
    {
      label: "Particulars",
      renderCell: item => (
        <div className="text-capitalize me-2">
          {item?.entries[0]?.ledger_name}
        </div>
      ),
    },

    // {
    //   label: "Date",
    //   renderCell: item => moment(item?.created_at).format("DD-MMM-YYYY"),
    // },
    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.side == "debit"
            ? NumberFormat(
                Math.abs(Number(item?.amount)),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}{" "}
          {/* {Number(item?.amount) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.side == "credit"
            ? NumberFormat(
                Math.abs(Number(item?.amount)),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}{" "}
          {/* {Number(item?.amount) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
  ]

  const accSubColumns = [
    // ...(shouldShowLedgerColumn ? [
    // {
    //   label: "Ledger",
    //   renderCell: item => (
    //     <div className="text-capitalize">
    //       {item?.ledger?.name ? item?.ledger?.name : "-"}
    //     </div>
    //   ),
    // },
    // ]: []),
    {
      label: "Date",
      renderCell: item => (
        <div>{moment(item?.transaction_date).format("DD-MMM-YYYY")}</div>
      ),
    },
    // {
    //   label: "Particulars",
    //   renderCell: item => (
    //     <div className="text-capitalize">{item?.entries[0]?.ledger_name}</div>
    //   ),
    // },
    {
      label: "Voucher Type",
      renderCell: item => (
        <div className="text-capitalize">{item?.ledger_name}</div>
      ),
    },
    {
      label: "Voucher No",
      renderCell: item => (
        <div className="text-capitalize">{item?.reference_number}</div>
      ),
    },
    // {
    //   label: "Date",
    //   renderCell: item => moment(item?.created_at).format("DD-MMM-YYYY"),
    // },
    {
      label: <div className="text-end pe-5">Credit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.side == "credit"
            ? NumberFormat(
                Math.abs(Number(item?.amount)),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}{" "}
          {Number(item?.amount) > 0 ? "Cr" : "Dr"}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {item?.side == "debit"
            ? NumberFormat(
                Math.abs(Number(item?.amount)),
                desimalrange,
                desimalrange
              )
            : NumberFormat(0, desimalrange, desimalrange)}{" "}
          {Number(item?.amount) > 0 ? "Cr" : "Dr"}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  // const handleSearchChange = data => {
  //   setSearch(data)
  //   setPage(1)
  // }

  const handleDateChange = (fromdate, todate) => {
    navigate(`${location.pathname}?${query.toString()}`, { replace: true })

    query.set("startDate", fromdate)
    query.set("endDate", todate)
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
    setDataPerPage(25)
  }

  const handleAccChange = data => {
    // navigate(`${location.pathname}?${query.toString()}`, { replace: true })
    query.set("ledger_id", data?.value)
    setAcc(data?.value)
    setAccData(data)
    setPage(1)
    if (data == undefined) {
      dispatch(removeFilter())
    }
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: `${bread ? bread : "Reports"}`, link: "/finance" },
                    ...(crumbdd || path == "/finance-account-book"
                      ? [{ title: crumbdd || "Account Book", link: "/finance" }]
                      : nameCiH
                      ? [{ title: nameCiH || "Account Book", link: "/finance" }]
                      : []),
                    ...(crumbaa
                      ? [
                          {
                            title: crumbaa || "Account Book",
                            link: "/finance-trial-balance",
                          },
                        ]
                      : NewnameCiH
                      ? [
                          {
                            title: NewnameCiH,
                            link: "/finance/cash-book-report",
                          },
                        ]
                      : []),
                    ...(crumb
                      ? [{ title: crumb, link: "/finance-balance-sheet" }]
                      : CHI
                      ? [{ title: CHI, link: `#` }]
                      : []),
                    {
                      title:
                        location?.pathname == "/finance-ledger-acc"
                          ? "Ledger Account"
                          : location?.pathname == "/finance/sundry-debtors"
                          ? "Client Report"
                          : location?.pathname == "/finance/account-payable"
                          ? "Supplier Report"
                          : "Ledger Summary",
                      // link:
                      //   location?.pathname == "/finance-ledger-acc"
                      //     ? "/finance-ledger-acc"
                      //     : "/finance-account-book",
                      link: "#",
                    },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <>
              {search ||
              dateFrom ||
              dateTo ||
              acc ||
              location?.state?.item?.ledger_id ||
              location?.state?.ledger_id ||
              location?.state?.id ||
              location?.state?.item?.id ||
              filters?.accData?.id ? (
                <>
                  <div className="me-2">
                    <span
                      id={`PopoverLegacy-1`}
                      className="px-2 btn btn-primary"
                    >
                      Download
                    </span>
                  </div>
                  <UncontrolledPopover
                    placement="bottom"
                    target={`PopoverLegacy-1`}
                    trigger="legacy"
                  >
                    <PopoverBody>
                      <div
                        className="table-popup-content"
                        onClick={() =>
                          downloadAccountBook({
                            params: `${
                              search ? `&searchText=${search}` : "&searchText"
                            }${
                              dateFrom
                                ? `&start_date=${moment(dateFrom).format(
                                    "YYYY-MM-DD"
                                  )}`
                                : ""
                            }${
                              dateTo
                                ? `&end_date=${moment(dateTo).format(
                                    "YYYY-MM-DD"
                                  )}`
                                : ""
                            }${
                              acc ||
                              location?.state?.item?.ledger_id ||
                              location?.state?.ledger_id ||
                              location?.state?.id ||
                              location?.state?.item?.id ||
                              filters?.accData?.value
                                ? `&ledger_id=${
                                    acc
                                      ? acc
                                      : location?.state?.item?.ledger_id ||
                                        location?.state?.ledger_id ||
                                        location?.state?.id ||
                                        location?.state?.item?.id ||
                                        filters?.accData?.value ||
                                        ""
                                  }`
                                : ""
                            }`,
                            type: "pdf",
                            fileName: "account_book.pdf",
                          })
                        }
                      >
                        PDF
                      </div>
                      {/* <div
                                                          className="table-popup-content"
                                                          onClick={() =>
                                                            downloadBalanceSheet("pdf", "balance_sheet.pdf")
                                                          }
                                                        >
                                                          PDF
                                                        </div> */}
                      <div
                        className="table-popup-content"
                        onClick={() =>
                          downloadAccountBook({
                            params: `${
                              search ? `&searchText=${search}` : "&searchText"
                            }${
                              dateFrom
                                ? `&start_date=${moment(dateFrom).format(
                                    "YYYY-MM-DD"
                                  )}`
                                : ""
                            }${
                              dateTo
                                ? `&end_date=${moment(dateTo).format(
                                    "YYYY-MM-DD"
                                  )}`
                                : ""
                            }${
                              acc ||
                              location?.state?.item?.ledger_id ||
                              location?.state?.ledger_id ||
                              location?.state?.id ||
                              location?.state?.item?.id ||
                              filters?.accData?.value
                                ? `&ledger_id=${
                                    acc
                                      ? acc
                                      : location?.state?.item?.ledger_id ||
                                        location?.state?.ledger_id ||
                                        location?.state?.id ||
                                        location?.state?.item?.id ||
                                        filters?.accData?.value ||
                                        ""
                                  }`
                                : ""
                            }`,
                            type: "excel",
                            fileName: "account_book.xlsx",
                          })
                        }
                      >
                        Excel
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </>
              ) : null}
            </>
          </div>
          {/* <Row> */}
          {/* <Col lg={3}> */}
          <Card className="me-2 px-2 pb-2">
            <JournalEntryFilter
              handleDateChange={handleDateChange}
              handleAccChange={handleAccChange}
              resetData={{
                accData: filters?.accData,
                dateFrom: filters?.dateFrom,
                dateTo: filters?.dateTo,
              }}
              initialLedger={
                location?.state?.item?.ledger_name ||
                location?.state?.ledger_name ||
                location?.state?.name ||
                filters?.accData?.label
                  ? {
                      label: location?.state?.item?.ledger_name
                        ? location?.state?.item?.ledger_name
                        : location?.state?.ledger_name
                        ? location?.state?.ledger_name
                        : location?.state?.name
                        ? location?.state?.name
                        : filters?.accData?.label,
                      value: location?.state?.item?.ledger_id
                        ? location?.state?.item?.ledger_id
                        : location?.state?.item?.id
                        ? location?.state?.item?.id
                        : location?.state?.ledger_id
                        ? location?.state?.ledger_id
                        : location?.state?.id
                        ? location?.state?.id
                        : filters?.accData?.value,
                    }
                  : null
              }
              initialDate={[
                location?.state?.startDate,
                location?.state?.endDate,
              ]}
              isImport={false}
            />
            <hr className="table-divide" />
            {/* </Col>
            <Col lg={9}> */}
            {/* <Card className="me-2 px-2 py-2"> */}
            {/* Show table if we have either acc from state or from location.state */}
            {(acc !== null && acc !== undefined) ||
            (filters?.accData?.value !== null &&
              filters?.accData?.value !== undefined) ||
            location?.state?.item?.ledger_id ||
            location?.state?.ledger_id ||
            location?.state?.id ||
            location?.state?.item?.id ? (
              <>
                <Row className="mt-2 ever-rise-table accTable">
                  <Col xs={12}>
                    <div
                      ref={tableContainerRef}
                      style={{ maxHeight: "350px", overflowY: "auto" }}
                    >
                      {fetchedData?.data?.data && (
                        <UpdateTable
                          className="mt-5"
                          nodes={fetchedData?.data?.data}
                          paginate={fetchedData?.data}
                          CurrentPage={page}
                          columns={columns}
                          handlePagination={handlePaginate}
                          handleSizePerPage={handleSizePerPageChange}
                          tableWidth="12% 15% 15% 20% 20% 17%"
                          mobileWidth="40% 40% 30% 30% 30% 30%"
                          hidePaginate={true}
                          isLoading={isLoadingNextPage}
                        />
                      )}
                    </div>
                    {/* {fetchedData?.data?.data && (
                          <UpdateTable
                            className="mt-5"
                            nodes={fetchedData?.data?.data}
                            paginate={fetchedData?.data}
                            CurrentPage={page}
                            columns={columns}
                            // expand={true}
                            // subHeader={false}
                            // subColumn={accSubColumns}
                            // subName={"entries"}
                            handlePagination={handlePaginate}
                            handleSizePerPage={handleSizePerPageChange}
                            tableWidth="12% 20% 20% 10% 20% 17%"
                            mobileWidth="40% 40% 30% 30% 30% 30%"
                          />
                        )} */}
                  </Col>
                  {fetchedData?.data?.data?.length ? (
                    <Row className="mt-2">
                      <Col lg={6}></Col>
                      <Col lg={6} className="text-muted">
                        <Row>
                          <Col lg={4}>Opening Balance</Col>
                          <Col lg={4} className="text-end pe-5 fw-bold">
                            {fetchedData?.openingBalance_type == "debit"
                              ? NumberFormat(
                                  Math.abs(
                                    Number(fetchedData?.openingBalance || 0)
                                  ),
                                  desimalrange,
                                  desimalrange
                                )
                              : "-"}
                          </Col>
                          <Col lg={4} className="text-end pe-5 fw-bold">
                            {fetchedData?.openingBalance_type == "credit"
                              ? NumberFormat(
                                  Math.abs(
                                    Number(fetchedData?.openingBalance || 0)
                                  ),
                                  desimalrange,
                                  desimalrange
                                )
                              : "-"}
                          </Col>
                        </Row>
                        <Row className="my-2">
                          <Col lg={4}>Current Balance</Col>
                          <Col lg={4} className="text-end pe-5 fw-bold">
                            {NumberFormat(
                              Math.abs(Number(fetchedData?.currentDebit || 0)),
                              desimalrange,
                              desimalrange
                            )}
                          </Col>
                          <Col lg={4} className="text-end pe-5 fw-bold">
                            {NumberFormat(
                              Math.abs(Number(fetchedData?.currentCredit || 0)),
                              desimalrange,
                              desimalrange
                            )}
                          </Col>
                        </Row>
                        <Row className="fw-bold">
                          <Col lg={4}>Closing Balance</Col>
                          <Col lg={4} className="text-end pe-5">
                            {fetchedData?.closingBalance_type == "debit"
                              ? NumberFormat(
                                  Math.abs(
                                    Number(fetchedData?.closingBalance || 0)
                                  ),
                                  desimalrange,
                                  desimalrange
                                )
                              : "-"}
                          </Col>
                          <Col lg={4} className="text-end pe-5">
                            {fetchedData?.closingBalance_type == "credit"
                              ? NumberFormat(
                                  Math.abs(
                                    Number(fetchedData?.closingBalance || 0)
                                  ),
                                  desimalrange,
                                  desimalrange
                                )
                              : "-"}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </Row>
              </>
            ) : (
              <div className="d-flex justify-content-center pt-5">
                Please Select Ledger
              </div>
            )}
            {/* </Card> */}
            {/* </Col> */}
            {/* </Row> */}
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LedgerAccounts
